// Client-side ordering rules of real-time events (REALTIME_DESIGN.md §7). Pure, so they are unit-tested.
//  v == last + 1 ⇒ apply · v <= last ⇒ ignore (duplicate/reordered) · v > last + 1 ⇒ gap ⇒ re-read the board.

export type SyncDecision = 'apply' | 'ignore' | 'resync';

export function decideEvent(lastVersion: number, eventVersion: number): SyncDecision {
  if (eventVersion <= lastVersion) return 'ignore';
  if (eventVersion === lastVersion + 1) return 'apply';
  return 'resync';
}

/** The connection states the UI must always show (never silently stale, REALTIME_DESIGN §8). */
export type ConnectionState = 'connecting' | 'live' | 'reconnecting' | 'polling';

export const REALTIME_TIMINGS = {
  /** No event or heartbeat for this long ⇒ the connection is presumed dead: reopen and re-read. */
  silenceMs: 45_000,
  /** Consecutive failures before switching to conditional polling. */
  failuresBeforePolling: 3,
  pollingMs: 10_000,
} as const;

export interface SlotChange {
  readonly slotId: string;
  readonly roomId: string;
  readonly state: 'FREE' | 'OCCUPIED' | 'MINE' | 'HELD';
  readonly occupantMemberId?: string;
}

export interface SlotsChangedEvent {
  readonly stayVersion: number;
  readonly slots: readonly SlotChange[];
}
